import { Mui, MuiIcons } from '@osu/react-ui';
import { useReducer } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useGetDashboardDataQuery } from '../services/graphql/api';
import { selectDashboardData } from '../services/graphql/slices/dashboard-slice';
import InProgressTable from './components/inprogress-table';
import { PullCard } from './components/pull-card';
import { tableFilterReducer } from './components/table-filter-reducer';
import ToggleButtonGroup from './components/toggle-button-group';
import { DASHBOARD_BUTTON_GROUP } from '../util/constants';
import useRoleAuthentication from '../Authentication/hooks/useRoleAuthentication';

const INITIAL_FILTER_STATE = {
  [DASHBOARD_BUTTON_GROUP.RESUMELATER.KEY]: true,
  [DASHBOARD_BUTTON_GROUP.ASSIGNED.KEY]: true,
};

const Dashboard = () => {
  const data = useSelector(selectDashboardData)
  const [filterState, dispatch] = useReducer(tableFilterReducer, INITIAL_FILTER_STATE);

  // Auto-redirect student workers to basic search
  const nav = useNavigate();
  const authDetails = useRoleAuthentication({autoMode: true, redirectOnUnauthorized: true });
  
  const { isLoading } = useGetDashboardDataQuery(undefined, { 
    refetchOnMountOrArgChange: true,
    skip: !(authDetails.roles?.length > 0) || authDetails.isStudent
  });
  
  if (authDetails.isStudent) { nav("/search"); return; }
  
  const filteredTableData = data?.inProgressReviews?.filter(row => {
    if (filterState.RESUMELATER && row.resumeLater) return true;
    if (filterState.ASSIGNED && row.manuallyAssigned) return true;
    return !filterState.RESUMELATER && !filterState.ASSIGNED;
  });

  const CardSkeleton = () => {
    return (
      <Mui.Grid item xs={12} sm={12} md={12} lg={12}>
        <Mui.Skeleton height={300} />
      </Mui.Grid>
    )
  }
  // console.log(data)
  return (
    <>
      <Mui.Box style={{ display: 'flex', flexDirection: 'column' }}>
        <Mui.Box mb={2}>
          <Mui.Grid container styles={{ flexGrow: '1' }} spacing={2}>
            {isLoading ? <CardSkeleton /> : data?.cards?.map((card) => {
              return (
                <Mui.Grid key={card.key} item xs={12} sm={6} md={6} lg={4}>
                  <PullCard card={card} />
                </Mui.Grid>
              )
            })}
          </Mui.Grid>
        </Mui.Box>

        <Mui.Box style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <Mui.Accordion defaultExpanded={true}>
            <Mui.AccordionSummary expandIcon={<MuiIcons.ExpandMore />} id={'1'} style={{ fontSize: '1rem' }}>
              <Mui.Typography sx={{ fontSize: "1.265rem", fontWeight: "bold" }}>In Progress</Mui.Typography>
            </Mui.AccordionSummary>
            <Mui.AccordionDetails>
              <Mui.Box style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <ToggleButtonGroup dispatch={dispatch} filterState={filterState} data={data} />
                <InProgressTable isLoading={isLoading} filteredTableData={filteredTableData} />
              </Mui.Box>
            </Mui.AccordionDetails>
          </Mui.Accordion>
        </Mui.Box >
      </Mui.Box >
    </>
  )
}

export default Dashboard